import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import { css } from '@repo/pandacss/styled-system/css';
import { memo } from 'react';
import { MdCheck, MdCheckBoxOutlineBlank } from 'react-icons/md';

const rootClass = css({
  display: 'inline-flex',
  paddingTop: '0',
  paddingRight: '0',
  paddingBottom: '0',
  paddingLeft: '0',
  flexShrink: '0',
});

type Props = {
  checked: boolean;
  onChange: () => void;
  disabled: boolean;
};

export const Checkbox = memo(({ checked, onChange, disabled }: Props) => (
  <BaseCheckbox.Root
    checked={checked}
    onCheckedChange={onChange}
    disabled={disabled}
    tabIndex={-1}
    className={rootClass}
    style={{ position: 'relative', width: 24, height: 24 }}
  >
    <MdCheckBoxOutlineBlank
      size={24}
      color={checked ? 'var(--colors-green-main, #008254)' : disabled ? '#ccc' : '#aaa'}
    />
    <BaseCheckbox.Indicator keepMounted>
      {checked && (
        <MdCheck
          size={18}
          color="var(--colors-green-main, #008254)"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}
        />
      )}
    </BaseCheckbox.Indicator>
  </BaseCheckbox.Root>
));
